import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { RootScopeService } from 'src/app/core/services/root-scope.service';
import { getCustomerDisplayName, sortCustomersByDisplayName } from '../../customers/customer-display';
import { customerDetails } from 'src/app/models/customers/details';
import { ComponentServices } from '../../services/component-services';
import { ApiService } from 'src/api.service';
import { Observable, Subscription } from 'rxjs';
import { OriginalFailuresBadgeService } from 'src/app/core/services/original-failures-badge.service';

@Component({
  selector: 'app-header',
  standalone: false,
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input() loading: boolean;
  public customersAvailable: customerDetails[] = [];
  source: string | undefined;
  customerId: string;
  menuItems: any;
  failedUploadsflag$: Observable<boolean | undefined>;
  dbAdminflag$: Observable<boolean | undefined>;
  /** Count of unreviewed "Processing Failure" errors; 0 hides the badge. */
  processingFailureCount = 0;
  /** True only when the current customer actually has the Original Failures page. */
  hasOriginalFailuresPage = false;
  /** True while the hamburger dropdown is open; moves the badge onto the menu row. */
  menuOpen = false;
  private badgeSubscription: Subscription;
  constructor( private router: Router, public rootScope: RootScopeService, public services: ComponentServices,
    private originalFailuresBadge: OriginalFailuresBadgeService) {
    // subscribe to the existing observable flag; adapt if RootScopeService exposes a signal instead
    this.failedUploadsflag$ = this.rootScope.failedUploadsFlag();
    this.dbAdminflag$ = this.rootScope.dbAdminFlag();

  }

  ngOnInit(): void {
    this.customersAvailable = sortCustomersByDisplayName(this.rootScope.globals.customers ?? []);
    this.source = this.rootScope.globals.source;
    this.customerId = this.rootScope.globals.currentCustomer;
    this.menuItems = this.rootScope.globals.menuItems
    this.hasOriginalFailuresPage = (this.menuItems ?? []).some(
      (item: any) => this.isOriginalFailuresItem(item));

    this.badgeSubscription = this.originalFailuresBadge.count$
      .subscribe(count => this.processingFailureCount = count);
  }

  /** Show the badge only when the customer has the page and there are unreviewed failures. */
  get showProcessingFailureBadge(): boolean {
    return this.hasOriginalFailuresPage && this.processingFailureCount > 0;
  }

  /**
   * The badge lives on the hamburger only while the dropdown is closed. Once it
   * opens, the count moves onto the Original Failures row so it points at the
   * page it refers to instead of at the (now redundant) menu icon.
   */
  get showHamburgerBadge(): boolean {
    return this.showProcessingFailureBadge && !this.menuOpen;
  }

  /** Identifies the dynamic menu entry that links to the Original Failures page. */
  isOriginalFailuresItem(item: any): boolean {
    return (item?.router_link ?? '').includes('original-failures');
  }

  /** Badge for a dropdown row: only the Original Failures row, only while open. */
  showMenuItemBadge(item: any): boolean {
    return this.menuOpen && this.processingFailureCount > 0 && this.isOriginalFailuresItem(item);
  }

  /** Badge label, capped at 99+ like a messaging app. */
  get processingFailureBadge(): string {
    return this.processingFailureCount > 99 ? '99+' : String(this.processingFailureCount);
  }

  ngOnDestroy(): void {
    this.badgeSubscription?.unsubscribe();
  }
  navigate(value:any){
    this.router.navigate([value]);
  }
  public getCustomerDisplayName = getCustomerDisplayName;

  public selectCustomer(str: string): void {
    if (this.rootScope.globals.currentCustomer != str) {
      this.services.switchCustomerActiveComponent(str).then(() => {
        this.ngOnInit();
      });
    }
  }
  /**
   * Function use to initiate the switching customer process.
   * @param custId: Customer Id Selected.
   */
  switchCustomer(custId: string) {
    this.services.InitializeCustomerSwitchingProcess(custId).then(
      () => {
        setTimeout(
          () => {
            this.ngOnInit();
          }, 5);
      }
    );
  }
}
